import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar} from 'swiper';
import 'swiper/components/scrollbar/scrollbar.scss';
import CustomCursor from '~/components/CustomCursor';

function Service({ heading, items=[] }) {

  SwiperCore.use([Scrollbar]);

  return (
    <section className="my-36 service-swiper overflow-hidden">
      <div className="container">
        <h2 className="text-secondary-h2 mb-20">{heading}</h2>
        <CustomCursor content="Drag" className="h-full w-full">
          <Swiper
            className="w-full"
            slidesPerView={`auto`}
            grabCursor="1"
            freeMode="1"
            scrollbar={{ draggable: true }}
            style={{ overflow: `visible` }}
          >
              {items.map((item, i) => (
                <SwiperSlide
                  className="max-w-[80%] mr-8 md:max-w-30 last:mr-0"
                  key={`hpswiper${i}`}
                  style={{ height: 'auto' }}>
                  <div className="border border-black h-full px-8 md:px-12 pt-24 pb-8 md:pt-32 md:pb-16 hover:bg-black hover:text-white transition-colors duration-300 ease-in-out">
                    <div className="flex flex-col">
                      <h3 className="text-secondary-h3 mb-6">{item.heading}</h3>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </CustomCursor>
      </div>
    </section>
  );
}

export default Service;
